export default "__VITE_ASSET__lpV2sZhz__"